import { ContactUsProps } from "../types/ContactUsProps";

export const contactusformdata: ContactUsProps = {
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    message: "",
};
